import * as universal from "../../../../src/routes/(public)/login/+page.ts";
export { universal };
export { default as component } from "../../../../src/routes/(public)/login/+page.svelte";